import React, { useState } from "react";
import styles from "../offlinePay.module.css";
import { Card, Col, Row } from "react-bootstrap";
import FileUploader from "../../onboarding/studentDetails/fileUpload";
import CommonButton from "../../CommonButton/CommonButton";
import { documentUploadApi } from "../../../api";
import { useMyContext } from "../../../myContext";

function OfflineRemitterDocs({ stepToShowOffline, setStepToShowOffline }) {
  const [loading, setLoading] = useState(false);
  const [aadharFrontFile, setAadharFront] = useState(null);
  const [aadharBackFile, setAadharBack] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [panFileType, setPanFileType] = useState(null);
  const [uploadError, setUploadError] = useState(false);
  const [aadharFrontFileType, setAadharFrontFileType] = useState(null);
  const [aadharBackFileType, setAadharBackFileType] = useState(null);
  const acceptedFormats = ".jpeg, .jpg, .png .pdf";
  const {offlineRemitterUserId} = useMyContext();

  const checkValidFile = (files) => {
    if (
      files.filter(
        (file) =>
          acceptedFormats.includes(file.type) ||
          acceptedFormats.includes(`.${file.name.split(".").pop()}`)
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handlePanDrop = (files) => {
    if (checkValidFile(files)) {
      setPanFile(files[0]);
      const fileExtension = files[0].name.split(".").pop();
      setPanFileType(fileExtension);
    }
  }

  const handleFrontAadharDrop = (files) => {
    if (checkValidFile(files)) {
      setAadharFront(files[0]);
      const fileExtension = files[0].name.split(".").pop();
      setAadharFrontFileType(fileExtension);
    }
  };

  const handleBackAadharDrop = (files) => {
    if (checkValidFile(files)) {
      setAadharBack(files[0]);
      const fileExtension = files[0].name.split(".").pop();
      setAadharBackFileType(fileExtension);
    }
  };

  const handleSuccess = () => {
      setStepToShowOffline(3);
  };

  const handleError = (error) => {
    setUploadError(true);
  };

  const uploadFile = async (file, fileType, docType, side) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await documentUploadApi(
        offlineRemitterUserId,
        fileType,
        docType,
        side,
        formData
      );
    } catch (error) {
      handleError(error);
      throw error;
    }
  };


  const frontAadharApi = () =>
    uploadFile(aadharFrontFile, aadharFrontFileType, "AADHAAR", "front");
  const backAadharApi = () =>
    uploadFile(aadharBackFile, aadharBackFileType, "AADHAAR", "back");
  const panApi = () => {
    uploadFile(panFile, panFileType, "PAN", "front");
  }

  const checkIfValid = async () => {
    if (aadharBackFile !== undefined && aadharFrontFile !== undefined && panFile !== undefined) {
      try {
        setLoading(true);
        Promise.all([
          frontAadharApi(),
          backAadharApi(),
          panApi()
        ]).then(() => {
          handleSuccess();
            setLoading(false);
        });
    }catch (error) {
      setLoading(false);
      }
    }
  };

  const onRemoveButton = (label) => {
    if (label === "PAN") {
      setPanFile(null);
      setPanFileType("");
    } else if (label === "Front of Aadhar") {
      setAadharFront(null);
      setAadharFrontFileType("");
    } else if (label === "Back of Aadhar") {
      setAadharBack(null);
      setAadharBackFileType("");
    }
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <Row className={styles.Title}>Documents Upload</Row>
        {stepToShowOffline >= 2 ? (
          <>
            <hr style={{ marginTop: "0px" }} />
            <div style={{ marginTop: "20px" }}>
              <Row style={{ marginBottom: "8px", justifyContent: "center" }}>
                <Col
                  md={12}
                  sm={12}
                  xs={12}
                  lg={4}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0px",
                  }}
                >
                  <FileUploader
                    onDrop={handlePanDrop}
                    acceptedFormats={acceptedFormats}
                    maxSize={5000000}
                    label="PAN"
                    loading={loading || stepToShowOffline !== 2}
                    showRemove={stepToShowOffline === 2}
                    onRemoveButton={() => onRemoveButton("PAN")}
                  />
                </Col>
                <Col
                  md={12}
                  sm={12}
                  xs={12}
                  lg={4}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0px",
                  }}
                >
                  <FileUploader
                    onDrop={handleFrontAadharDrop}
                    acceptedFormats={acceptedFormats}
                    maxSize={5000000}
                    label="Front Aadhar"
                    loading={loading || stepToShowOffline !== 2}
                    showRemove={stepToShowOffline === 2}
                    onRemoveButton={() => onRemoveButton("Front of Aadhar")}
                  />
                </Col>
                <Col
                  md={12}
                  sm={12}
                  xs={12}
                  lg={4}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0px",
                  }}
                >
                  <FileUploader
                    onDrop={handleBackAadharDrop}
                    acceptedFormats={acceptedFormats}
                    maxSize={5000000}
                    label="Back Aadhar"
                    loading={loading || stepToShowOffline !== 2}
                    showRemove={stepToShowOffline === 2}
                    onRemoveButton={() => onRemoveButton("Back of Aadhar")}
                  />
                </Col>
              </Row>
            </div>
            {stepToShowOffline === 2 && <><Row className={styles.allowedFormat}>
                Allowed Formats are jpeg, png, jpg, pdf and the size should be
                less then 5MB
              </Row>
              <Row className={styles.allowedFormat} style={{marginTop: "2px", color: "red", fontSize: "12px"}}>
            Please ensure the documents uploaded for Proof of Identity are accurate.
            </Row></>}
            {stepToShowOffline === 2 && <Row className="pt-3 mt-3">
              <Col md={3}>
                <CommonButton
                  title="Next"
                    onClick={checkIfValid}
                    loading={loading}
                    disabled={loading || (aadharFrontFile === null || aadharBackFile === null || panFile === null)}
                  width={"150px"}
                />
              </Col>
            </Row>}
          </>
        ) : (
          ""
        )}
      </Card.Body>
    </Card>
  );
}

export default OfflineRemitterDocs;
